function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M41.26,17c4.34-2.34,8.34-3.7,10.9-4.52-4.38-1.93-9-2.73-13.51-2.52.37,2.56,1.27,4.92,2.61,7.05Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M9.98,38.05c-.38,5.94,1.03,11.85,3.96,16.95.71-5.07,2.07-9.69,3.99-13.99-2.25-1.57-5.04-2.59-7.95-2.97Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M38.83,18.38c-1.68-2.35-2.7-5.14-3.08-8.16-7.13,1.02-13.81,4.57-18.62,10.19,2.58.73,7.08,2.31,12.46,4.78,2.77-2.54,5.89-4.85,9.24-6.81Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M29.94,28.66c-3.58,3.46-6.35,7.28-8.55,11.55,2.19,1.85,3.93,4.27,5.08,6.93l1.5,3.35c2.31,5.08,5.77,9.47,10.05,12.7,6.24,4.62,11.78,5.2,11.78,5.2,0,0,.02,0,.03,0,3.68-1.28,7.12-3.28,10.09-5.9-2.86-15.7-15.62-26.83-29.98-33.84Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M26.5,66.88c4.31,2.17,8.91,3.2,13.44,3.2,1.32,0,2.63-.09,3.94-.26-2.12-.83-4.79-2.16-7.46-4.19-4.74-3.58-8.55-8.32-10.97-13.86l-1.5-3.35c-.92-2.08-2.19-3.93-3.7-5.43-2.07,4.71-3.33,9.98-3.8,15.72,2.64,3.33,6.02,6.16,10.06,8.18Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M51.19,27.51l-3.35-1.5c-2.89-1.27-5.31-3-7.28-5.31-3,1.73-5.77,3.81-8.2,5.89,14.11,7.23,26.51,18.11,30.07,33.43,1.72-1.93,3.24-4.1,4.46-6.52.84-1.66,1.5-3.37,2-5.1-.33-1.75-1.53-5.94-4.76-10.49-3.23-4.5-7.74-8.09-12.94-10.4Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M55.93,14.48c-.83.16-6.27,1.4-12.82,4.83,1.62,1.73,3.58,3.12,5.77,4.16l3.35,1.5c8.3,3.52,14.46,9.96,17.74,17.64.95-11.02-4.27-22.03-14.04-28.14Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M10.3,35.18c3.22.39,6.22,1.52,8.9,3.3,2.19-4.04,4.85-7.74,8.09-11.09-5.52-2.43-10.08-3.9-12.09-4.43-.76,1.12-1.47,2.29-2.09,3.54-1.4,2.81-2.33,5.74-2.8,8.68Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/VirtualSports-active.14b3b6bc.svg";
export { SvgComponent as ReactComponent };